<template>
  	<div>
  		<mt-header fixed :title="$t('我的财富')">
          <mt-button icon="back" slot="left" onclick="window.history.go(-1)"></mt-button>
          <mt-button slot="right" @click="query()">{{$t('交易查询')}}</mt-button>
        </mt-header>
        <div class="header">
			<img src="../../assets/img/coinDetail/bg_bizhongxiangqing.png" alt="" class="bg">
			<p class="amount wx_fontSize5">
				{{$t('财富资产')}}({{currency}})
			</p>
			<p class="asset wx_fontSize4">{{total*currency_usd_rate | numFilter | toThousandFilter}}</p>
			<p class="address wx_fontSize2">
				{{$t('累计收益')}} {{currency_char}} {{revenue*currency_usd_rate | numFilter | toThousandFilter}}
			</p>
		</div>

		<div class="content" style="display: block;">
			<ul class="content_detail">
                <li  v-for="val in pos"  @click="plandetail(val.name,val.wealth_pid,val.coin_symbol)">
                    <img v-bind:src="val.coin_icon" class="oImg">
                    <span class="currency_name">{{val.name}}</span>
                    <div class="amount_of wx_rt">
                        <p class="count wx_fontSize3">{{val.annualized_returns}}</p>
                    </div>
                    <div class="clear"></div>
                    <span class="left_lable" v-for="val in val.flag" >{{val}}</span>
                    <span class="right_lable">{{$t('预期年化收益')}}</span>
                </li>
			</ul>
		</div>
  	</div>
</template>

<script>
    import { httpGetMywealth } from "@/api/wealth";
	export default {
        data:function() {  
            return {  
                currency:'',
                currency_char:'',
                currency_usd_rate:'',
                pos:[],
                total:0,
                revenue:0,
            }  
        }, 
        activated(){
            this.currency = this.$store.state.currency, 
            this.currency_char = this.$store.state.currency_char,
            this.currency_usd_rate = this.$store.state.currency_usd_rate,
            this.getMywealth();
        },
        filters: {
            numFilter(value) {
                let transformVal = Number(value).toFixed(6);
                let realVal = transformVal.substring(0, transformVal.length);
                return Number(realVal);
            }
        },
		methods:{
            getMywealth: function() {
                httpGetMywealth()
                .then(res => {
                    this.pos = res.data.list;
                    this.total = res.data.total;
                    this.revenue = res.data.revenue;
                })
                .catch(() => {});
            },
			query(){
            	this.$router.push('/query')
            },
            plandetail(title,id,coin_symbol){
                this.$router.push({path:"/ploydetail",query:{title:title,id:id,coin_symbol:coin_symbol}})
            },
            receive(){
            	this.$router.push('/receive')
            }
		}
	}
</script>
<style scoped>
#mywealth{width:100%;height:100%;overflow: hidden;position: fixed;background:#f6f6f6;}
.mint-header{background: transparent;}
.header{width:100%;height:234px;position: relative;text-align: center;}
.header .bg{width:100%;height:100%;}
.amount{position:absolute;top:80px;color:#fff;font-size: 14px;}
.asset{
	color: #fff;
    position: absolute;
    top: 110px;
    font-size: 40px;
}
.add{width:54px;height:54px;position: absolute;right: 15px;top:60px;}
.address{
    position: absolute;
    top: 166px;
    color: #fff;
}
.address img{width:13px;height:13px;margin-left: 10px;}
.select{position: absolute;bottom:0;height:56px;width:100%;background:rgba(225,225,225,0.15);color:#fff;}
.select li{width:calc((100% / 3) - 4px);height: 30px;margin-top: 13px;border-right: 2px solid rgba(225,225,225,0.3);float: left;text-align: center;line-height: 30px;}
.select li img{width:19px;height: 19px;margin-left: -6px;position: relative;top:4px;}
.select li span{margin-left:12px;}
/*内容*/
.content{width:100%;}
.local{padding-top:0;}
.content_detail{padding:0 15px 0 15px;}
.content_detail li{position: relative;width:100%;background:#fff;margin-top:12px;height: 78px;}
.oImg{
    width: 34px;
    height: 34px;
    margin: 15px 10px 5px 14px;
}
.currency_name{
	position: relative;
    top: -20px;
    font-size: 14px;
    font-weight: bold;
}
.amount_of{width:25%;text-align: center;}
.count{color:#0191f5;padding:22px 0 10px 0;font-weight: bold;}
.money{color:#8c92a8;}

.block_list{width:100%; display: none;}
.block_list img{margin-top: 62px;width:264px;margin-left: calc(50% - 132px);}
.tip{color:#8c92a8;width:100%;text-align: center;position: relative;top:-40px;}
p{
	width: 100%;
}

.left_lable{
    font-size: 12px;
    margin: 0 0 0 58px;
    float: left;
    color: #a9afc8;
    line-height: 16px;
    position: absolute;
    bottom: 15px;
}
.right_lable{
	font-size: 12px;
    color: #8c92a8;
    position: absolute;
    bottom: 15px;
    right: 5%;
}
.clear{
	clear: both;
}
.line{
	width: 0;
    height: 40px;
    border-right: 1px solid #e3e8ed;
    position: absolute;
    left: 50%;
    z-index: 1;
    top: 16px;
}
</style>
